import React from "react";
import { useNavigate } from "react-router";

/**
 * 前ページに戻るボタンコンポーネント
 * @param {string} title タイトル
 * @param {string} [size="large"] サイズ
 * @param {Function} onClick ボタン押下時の処理
 */
export default function BackButton({ title = "戻る", onClick }) {
  const navigate = useNavigate();
  /**
   * onClick が指定されていれば指定された処理を実行する
   * onClick が未指定なら、前のページに戻る
   * @memberof BackButton
   */
  const onBack = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };
  return (
    <button className="btn btn-outline back-btn" onClick={onBack}>
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M15 18l-6-6 6-6M9 12h12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {title}
    </button>
  );
}
